import { AlluraErrorBoundary } from 'components/core/AlluraErrorBoundary/AlluraErrorBoundary';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import React from 'react';

interface Props {
  title: string;
  isOpen: boolean;
  close: () => void;
  children: React.ReactNode;
}

export const VerificationWrapperDialog = ({ title, isOpen, close, children }: Props) => {
  return (
    <ConfirmationDialog
      dialogTitle={title}
      maxWidth="xs"
      padding={24}
      hasHeaderBar={false}
      hasOverflowY
      isDialogOpen={isOpen}
      hasBottomBar={false}
      handleCloseDialog={close}
      disableBackdropClick
    >
      <AlluraErrorBoundary>{children}</AlluraErrorBoundary>
    </ConfirmationDialog>
  );
};
